import React from 'react';
import Container from 'react-bootstrap/Container';

const Trustedby = () => {
  const companyLogos = [
    { logo: './assets/Gaviota.png', url: 'https://www.gaviotagroup.com/en/', name: 'Gaviota' },
    { logo: './assets/folda-logo.png', url: 'https://folda.com.lb/', name: 'Folda' },
    { logo: './assets/sidem.png', url: 'https://www.sidemalu.com/', name: 'Sidem' },
    { logo: './assets/rkco.png', url: 'http://robertkashouh.com/', name: 'Robert Kashouh' },
  ];

  return (
    <section className="trusted-section-enhanced">
      <Container>
        <div className="section-header section-header-dark">
          <span className="section-label section-label-dark">Our Partners</span>
          <h2 className="section-title section-title-dark">Trusted By Industry Leaders</h2>
          <p className="section-subtitle section-subtitle-dark">
            We're proud to partner with leading companies who trust us with their metal finishing needs.
          </p>
        </div>
        <div className="trusted-logos-grid">
          {companyLogos.map((company, index) => (
            <a
              key={index}
              href={company.url}
              target="_blank"
              rel="noopener noreferrer"
              className="trusted-logo-link"
            >
              <div className="trusted-logo-wrapper">
                <img
                  src={company.logo}
                  alt={company.name}
                  className="trusted-logo-img"
                />
              </div>
              <span className="trusted-logo-name">{company.name}</span>
            </a>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Trustedby;
